"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PreviewerContext_1 = __importDefault(require("../PreviewerContext"));
const PreviewerPageWrapper = ({ backgroundSource, background, centerItems, children, }) => {
    const { Render, theme } = (0, react_1.useContext)(PreviewerContext_1.default);
    const frameStyle = (0, react_1.useMemo)(() => ({
        backgroundColor: background
            ? theme.colors[background].main
            : 'transparent',
        width: '100%',
        height: '100%',
    }), [background, theme.colors]);
    const pageStyle = (0, react_1.useMemo)(() => ({
        backgroundColor: background ? theme.colors[background].main : 'transparent',
        width: '100%',
        height: '100%',
        alignItems: centerItems ? 'center' : undefined,
        justifyContent: centerItems ? 'center' : undefined,
    }), [background, theme.colors, centerItems]);
    const pageBase = backgroundSource
        ? (react_1.default.createElement(Render.ImageBackground, { style: pageStyle, source: backgroundSource, resizeMode: "cover" }, children))
        : (react_1.default.createElement(Render.View, { style: pageStyle }, children));
    return (react_1.default.createElement(Render.SafeAreaView, { style: frameStyle },
        react_1.default.createElement(Render.StatusBar, { backgroundColor: theme.colors[background || 'primary'].main, barStyle: "light-content", hidden: false }),
        pageBase));
};
exports.default = PreviewerPageWrapper;
